import { createMiddleware } from '../../../../shared/redux';
import {
    getOrderSimulation,
    setInitialOrderSimulation,
    EDIT_ORDER_SIMULATION,
    GET_INITIAL_ORDER_SIMULATION,
} from './simulation.state';
import { getCurrentOrder, updateOrder } from '../order.state';
import { getSubscriptionData } from '../../subscription/subscription.state';

export const simulationMiddlewares = createMiddleware({
    [GET_INITIAL_ORDER_SIMULATION]: state => setInitialOrderSimulation({
        subscription: getSubscriptionData(state),
    }),
    [EDIT_ORDER_SIMULATION]: (state, action) => {
        const { preventRequest } = action.payload.simulation;
        if (preventRequest) return [];

        const order = getCurrentOrder(state).data;
        const {
            seats, planId, addonIds, currency,
        } = getOrderSimulation(state);

        return updateOrder({
            id: order.id,
            paymentIntentId: order.payment.intentId,
            composition: {
                seats,
                planId,
                addonsIds: addonIds,
                currency,
            },
        });
    },
});
